import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'state/storeHooks';

import { getApplicantJourney } from 'services/applicantJourney';
import { isJourneyTrackingApiEnabled } from 'utils/applicantJourneyTracking';

export type ResolveActiveResponseIdState = {
  navigation: {
    leadProfileResponseId?: string;
    currentTabIndex: number;
  };
  leadProfile: {
    applicants: Array<{ responseId?: string }>;
  };
  application: {
    activeResponse?: { responseId?: string };
    applicant?: { currentResponse?: { responseId?: string } };
  };
};

function resolveActiveResponseId(state: ResolveActiveResponseIdState): string | undefined {
  const { leadProfileResponseId, currentTabIndex } = state.navigation;
  const { applicants } = state.leadProfile;

  return (
    leadProfileResponseId ??
    applicants[currentTabIndex]?.responseId ??
    state.application.activeResponse?.responseId ??
    state.application.applicant?.currentResponse?.responseId
  );
}

export function useApplicantJourney(isOpen: boolean) {
  const responseId = useSelector(resolveActiveResponseId);
  const isEnabled = isJourneyTrackingApiEnabled() && isOpen && Boolean(responseId);

  return useQuery({
    queryKey: ['lead-profile-journey', responseId],
    queryFn: () => getApplicantJourney({ responseId: responseId as string, limit: 50 }),
    enabled: isEnabled,
  });
}

export { resolveActiveResponseId };
